/* eslint-disable */
// add a css variable to fix 100%/100vw problem
// 100% = 100vw - var(--scrollbar-width)
document.documentElement.style.setProperty(
	'--scrollbar-width',
	`${window.innerWidth - document.documentElement.clientWidth}px`
)
